import React from 'react';

import MiniCard from '../../minicard/minicard';
import ListWrapper from './list-wrapper';
import ConfirmationModal from '../../confirmation-modal/confirmation-modal';
import ContentTypes from '../../../utils/content-types';

export default class MiniCardList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            item: null,
            onConfirm: null,
        };
    }

    updateNestedItem = (key, value) => {
        const { card, name } = this.props;
        this.props.updateNestedItem(name, { ...card, [key]: value });
    };

    updateNestedArray = (index, value) => {
        const cards = [...this.props.card.minicards];
        value !== undefined ? cards[index] = value : cards.splice(index, 1);
        this.updateNestedItem('minicards', cards);
    };

    addNewItem = () => {
        this.updateNestedArray(this.props.card.minicards.length, ContentTypes.MINICARDS.build());
    };

    render() {
        const { card, match, links } = this.props;
        return (
            <ListWrapper
                {...card} links={links}
                updateNestedItem={this.updateNestedItem}
                addNewItem={this.addNewItem}
            >
                <div className='class-resources-wrapper'>
                    <div className='mincards-wrapper flex-horizontal'>
                        {card.minicards
                            .map((card, i) => (
                                <MiniCard
                                    card={card}
                                    key={card.id}
                                    url={match.url}
                                    finished={false}
                                    onDelete={() => this.setState({
                                        onConfirm: () => this.updateNestedArray(i, undefined),
                                    })}
                                />
                            ))}
                    </div>
                </div>
                {
                    this.state.onConfirm &&
                    <ConfirmationModal
                        show={true}
                        msg={this.state.msg}
                        onClose={() => this.setState({ onConfirm: null, msg: null })}
                        onConfirm={this.state.onConfirm}
                    />
                }
            </ListWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/minicard-list.js